import React, {useEffect, useState} from "react";
import rapidex from '../images/rapidex.png';
import caixaAssistencia from '../images/caixa_assistencia.png';
import { getParametrosURL } from "../componentes/apoio/suporte";

export default function PaginaErro() {
    const [mensagemErro, setMensagemErro] = useState();

    useEffect(() => {
        let paramURL = getParametrosURL();

        if (paramURL?.erro) {
            switch(paramURL.erro) {
                case "101":
                    setMensagemErro("Falha no recebimento dos parâmetros de segurança");
                    break;

                case "102":
                    setMensagemErro("102 - Tente novamente em alguns minutos");
                    break;
    
                case "103":
                    setMensagemErro("Id da pré-venda não informada");
                    break;

                case "104":
                    setMensagemErro("Erro na leitura das informações de pré-venda");
                    break;

                case "105":
                    setMensagemErro("Esta unidade de vendas não pode ser selecionada como ponto de vendas");
                    break;

                case "106":
                    setMensagemErro("Erro na criação do boleto");
                    break;

                case "107":
                    setMensagemErro("Erro na geração do número da proposta");
                    break;

                case "108":
                    setMensagemErro("Proposta já encerrada");
                    break;

                case "109":
                    setMensagemErro("Código do colaborador não encontrado");
                    break;

                case "110":
                    setMensagemErro("Informações do vendedor não informado pelo SSO");
                    break;

                case "111":
                    setMensagemErro("Tente novamente em alguns minutos");
                    break;

                case "150":
                    setMensagemErro("No momento, não consta nenhum produto Rapidex a ser ofertado. Tente como pessoa fisíca");
                    break;

                case "500":
                    setMensagemErro("Ocorreu um erro. Código [" + paramURL?.idprevenda + "]");

                    break;
                        
                case "999":
                    setMensagemErro("Informações da venda não encontrada");
                    break;                    
    
                default:
                    setMensagemErro("Ocorreu um erro interno");
                    break;
            }
        }
        else {
            setMensagemErro("Página não encontrada");
        }
    }, [])

    return (
        <div className="d-flex flex-column w-100 align-items-center">
            <div className="d-flex flex-column bg-padrao align-items-center" style={{width: "1150px"}}>
                <div className="d-flex flex-row justify-content-between w-100">
                    <div style={{marginLeft: "10px", marginTop: "10px"}}>
                        <img src={rapidex} alt=""></img>
                    </div>
                    <img src={caixaAssistencia} alt=""></img>
                </div>
                {mensagemErro &&
                    <div style={{marginTop: "200px", marginBottom: "300px"}}>
                        <h1><center>{mensagemErro}</center></h1>
                    </div>
                }
            </div>
        </div>
    )
}